<template>
  <v-container fluid class="pa-6">
    <v-row>
      <v-col cols="12" class="d-flex align-center mb-6">
        <v-btn icon @click="$router.go(-1)" class="mr-4"><v-icon>mdi-arrow-left</v-icon></v-btn>

      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="proj in projects" :key="proj._id" cols="12" sm="6" md="4" lg="3">
        <v-card 
          class="pa-6 text-center hover-card d-flex flex-column justify-space-between" 
          height="100%"
          @click="goToEmployees(proj._id)"
          outlined
          style="border-radius: 4px; border: 1px solid #e0e0e0;"
        >
          <div class="d-flex justify-center align-center mb-6 mt-2">
            <v-icon size="32" color="#005f32" class="mr-3">mdi-bullseye-arrow</v-icon>
            <span class="text-subtitle-1 font-weight-regular" style="color: #333;">{{ proj.projectName || 'Unnamed Project' }}</span>
          </div>
          <v-btn small outlined color="#005f32" class="px-2 mb-2" @click.stop="goToEmployees(proj._id)">
            VIEW
          </v-btn>
        </v-card>
      </v-col>
      <v-col v-if="projects.length === 0 && !loading" cols="12" class="text-center mt-10">
        <v-alert type="info" text>No projects found for this division.</v-alert>
      </v-col>
      <v-col v-if="loading" cols="12" class="text-center mt-10">
        <v-progress-circular indeterminate color="#005f32"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CareerGraphProject',
  data() {
    return { 
      projects: [],
      loading: true
    };
  },
  async created() {
    await this.fetchProjects();
  },
  methods: {
    async fetchProjects() {
      try {
        const divisionId = this.$route.params.divisionId;
        const token = localStorage.getItem('token');
        const res = await axios.get('/career-graph/projects/' + divisionId, { 
          headers: { 'x-auth-token': token } 
        });
        if (res.data.status) {
          this.projects = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching projects:", e);
      } finally {
        this.loading = false;
      }
    },
    goToEmployees(projectId) {
      this.$router.push({ name: 'CareerGraphEmployee', params: { projectId } });
    }
  }
};
</script>

<style scoped>
.transition-swing {
  transition: all 0.3s ease;
}
.transition-swing:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.2) !important;
}
</style>
